window.ReportingSettingsManagementAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['ReportingSettingsManagement']);

    self.getServiceSettings = cacheService.cache(async (brandId, serviceCode) => {
        const url = `brands/${brandId}/services/${serviceCode}/reporting_settings`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    })[0];
});
